// TipsLayout.tsx
import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

const TipsLayout: FC = () => {
    return (
        <Box width="100%" display="flex" flexDirection="column">
            <Outlet />
        </Box>
    );
};

export default TipsLayout;